import { render, staticRenderFns } from "./AssignAgentGroupToProject.vue?vue&type=template&id=b8af6146&scoped=true"
import script from "./AssignAgentGroupToProject.vue?vue&type=script&lang=js"
export * from "./AssignAgentGroupToProject.vue?vue&type=script&lang=js"
import style0 from "./AssignAgentGroupToProject.vue?vue&type=style&index=0&id=b8af6146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8af6146",
  null
  
)

export default component.exports